module.exports = __webpack_public_path__ + "static/media/me.812166fb.svg";